import { useQuery } from "@tanstack/react-query";
import Router from "..";

export const useNewCampaigns = () => {
  return useQuery({
    queryKey: ["dashboard", "newCampaigns"],
    queryFn: async () => {
      const res = await Router.Api.getNewCampaigns();
      return res ?? [];
    },
    staleTime: 1000 * 60,
  });
};

export const usePopularCampaigns = () => {
  return useQuery({
    queryKey: ["dashboard", "popularCampaigns"],
    queryFn: async () => {
      const res = await Router.Api.getPopularCampaigns();
      return res ?? [];
    },
    staleTime: 1000 * 60,
  });
};

export const useTrendingHashtags = () => {
  return useQuery({
    queryKey: ["dashboard", "trendingHashtags"],
    queryFn: async () => {
      const res = await Router.Api.getTrendingHashtags();
      return res ?? [];
    },
    staleTime: 1000 * 60,
  });
};

export const useDailyTopCreators = () => {
  return useQuery({
    queryKey: ["dashboard", "dailyTopCreators"],
    queryFn: async () => {
      const res = await Router.Api.getDailyTopCreators();
      return res ?? [];
    },
    staleTime: 0,
  });
};
